/* @flow */
import NavigationList, { TOUCH_KEY } from './NavigationList.jsx';
import QUERY from 'queries/navigationList.gql';

export { QUERY, TOUCH_KEY };
export default NavigationList;
